export default __webpack_public_path__ + "static/media/survey.599027d8.svg";